export default __webpack_public_path__ + "static/media/pw.5fa73249.svg";